import { Routes } from '@angular/router';
import { ModulePaths } from '@constants/url.constant'
import { inject } from '@angular/core';
import { VisitListService } from '@services/visit-list/visit-list.service';
import { AuthGuard } from './guards/auth/auth.guard';
export const routes: Routes = [
    {
        path: ModulePaths.HOME,
        async loadChildren() {
            const c = await import('@modules/home/home.routes');
            return c.HomeRoutes
        },
        resolve: async () => {
            const visitListService = inject(VisitListService);
            const visits = (await visitListService.fetchNewBackboneVisits().catch(err => {
                console.error(err)}));
            return;
        },
        canActivate : [AuthGuard]
    },
    {
        path: ModulePaths.AUTH,
        async loadChildren() {
            const c = await import('@modules/auth/auth.routes');
            return c.AuthRoutes
        },
    },
    {
        path: ModulePaths.ERROR,
        async loadComponent() {
            const c = await import('@error-pages/generic-error/generic-error.page');
            return c.GenericErrorPage
        }
    },
    {
        path: ModulePaths.PUBLIC,
        async loadChildren() {
            const c = await import('@modules/public/public.routes');
            return c.PublicRoutes
        }
    },
    {
        path: '',
        redirectTo: ModulePaths.HOME,
        pathMatch: 'full'
    },
    {
        path: '**',
        async loadComponent() {
            const c = await import('@error-pages/not-found/not-found.page');
            return c.NotFoundPage
        }
    }
];
